import * as e from "react";
const r = ({
  title: l,
  titleId: t,
  ...a
}) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": t,
    ...a
  },
  l ? /* @__PURE__ */ e.createElement("title", { id: t }, l) : null,
  /* @__PURE__ */ e.createElement("path", { d: "M22 5.001h-8v2h4.586L13 12.587l-3-3L2 17.585l1.415 1.414 6.583-6.584 3 3 7-7v4.586h2z" })
);
export {
  r as default
};
